/* eslint-disable max-classes-per-file */
export class Subtyp1 {
    static readonly drivningspunkt = "Drivningspunkt";
    static readonly hansynLinje = "Hänsyn linje";
    static readonly vag = "Väg";
    static readonly drivningslinje = "Drivningslinje";
    static readonly hansynYta = "Hänsyn yta";
    static readonly anvisningYta = "Anvisning yta";
    static readonly hansynPunkt = "Hänsyn punkt";
    static readonly allmanlinje = "Allmän linje";
    static readonly allmanpunkt = "Allmän punkt";
}

export class Subtyp2 {
    static readonly vattendrag = "Vattendrag";
    static readonly kraftledning = "Kraftledning";
    static readonly bilvag = "Bilväg";
    static readonly basvag = "Basväg";
    static readonly vinterbilbasvag = "Vinterbilbasväg";
    static readonly avlagg = "Avlägg";
    static readonly overfart = "Överfart";
    static readonly ovrigDrivningspunkt = "Övrig drivningspunkt";
    static readonly ovrigOverfartDrivningstext = "Drivningstext";
    static readonly ovrigOverfartKojplats = "Kojplats";
    static readonly ovrigOverfartLarmpunkt = "Larmpunkt";
    static readonly kulturMiljo = "Kulturmiljö";
    static readonly sankmark = "Sankmark";
    static readonly berg = "Berg";
    static readonly blockmark = "Blockmark";
    static readonly mindreVattendrag = "Mindre vattendrag";
    static readonly backA = "Bäck/å";
    static readonly jordkabel = "Jordkabel";
    static readonly stup = "Stup";
    static readonly skyddsdike = "Skyddsdike";
    static readonly stig = "Stig";
    static readonly brantStup = "Brant/stup";
    static readonly dike = "Dike";

    // Special typ endast frontend
    static readonly avlaggLarmpunkt = "Avlägg & Larmpunkt";

    static readonly AllmanLinjeSubtyp2Lista = [
        this.mindreVattendrag,
        this.backA,
        this.jordkabel,
        this.stup,
        this.skyddsdike,
        this.stig,
        this.dike
    ];
    static readonly AllmanPunktSubtyp2Lista = [
        this.sankmark,
        this.berg,
        this.blockmark,
        this.brantStup
    ];
}

export class Subtyp3 {
    static readonly ovrigOverfartKojplats = "Kojplats";
    static readonly ovrigOverfartLarmpunkt = "Larmpunkt";
}
